/** Turns `owner/repo#12`, `owner/repo@sha` and URLs into links; everything else stays text. */
export function refUrl(ref: string): string | null {
	const t = ref.trim()
	if (/^https?:\/\//.test(t)) return t
	let m = t.match(/^([\w.-]+\/[\w.-]+)#(\d+)$/)
	if (m) return `https://github.com/${m[1]}/issues/${m[2]}`
	m = t.match(/^([\w.-]+\/[\w.-]+)@([0-9a-f]{7,40})$/i)
	if (m) return `https://github.com/${m[1]}/commit/${m[2]}`
	m = t.match(/^([\w.-]+\/[\w.-]+):([\w./-]+)@([\w./-]+)$/)
	if (m)
		return `https://github.com/${m[1]}/actions?query=branch%3A${encodeURIComponent(m[3] ?? "")}`
	return null
}

export const shortId = (id: string) => id.slice(0, 8)
